import { SoftManagerService } from './lib/softManager';
import { ISoftEvents } from './lib/softManager/interfaces';
import { IOffersProposalManager } from './lib/offersProposalManager';
import {
  IOffersProposalDetail,
  IProposalCard,
  IProposalAction,
} from './lib/offersProposalManager/interfaces';
import { EnergyManagerService } from './lib/energyManager';
import { IEnergyManager } from './lib/energyManager/interfaces';

export const offersProposalManager = new IOffersProposalManager();
export const energyManager = new EnergyManagerService();

export type { IOffersProposalDetail, IProposalCard, IProposalAction, IEnergyManager };

export { SoftManagerService, ISoftEvents };
